import { breakpoints, Column, Columns, Stack } from '@etg/wings';
import { ContentWrapper } from '@eti/components';
import { useProperty, useTranslation } from '@eti/providers';
import { css } from '@eti/styles';
import { screenReadersOnlyStyles } from '../../../../../utils/styleUtils';
import { useRoutedTabs } from '../../../../../widgets/tabs/components/RoutedTabs';
import FaqSection from '../../common/FaqSection';
import { useOrderDetails } from '../../../containers/OrderDetailsContext';
import BaggageDetails from './BaggageDetails';
import CheckInInfo from './CheckInInfo';

const contentWrapperStyles = css`
  margin-bottom: 40px;
  margin-top: 16px;

  @media (min-width: ${breakpoints._768}) {
    margin-top: 24px;
  }
`;

const OrderDetailsCheckIn = () => {
  const { p } = useProperty();
  const { t } = useTranslation();
  const { tabHeading1Ref } = useRoutedTabs();
  const faqSectionSlug = p('OrderDetails.CheckIn.Faq.Slug');
  const { faqSectionPerSlug } = useOrderDetails();

  return (
    <ContentWrapper className={contentWrapperStyles}>
      <Stack>
        <h1 className={screenReadersOnlyStyles} ref={tabHeading1Ref} tabIndex={-1}>
          {t('OrderDetails.Tab.CheckIn.Description')}
        </h1>
        <Columns spacing={16}>
          <Column width={{ [breakpoints._0]: '4/4', [breakpoints._970]: '4/6' }}>
            <CheckInInfo />
          </Column>
          <Column width={{ [breakpoints._0]: '4/4', [breakpoints._970]: '2/6' }}>
            <Stack>
              <BaggageDetails />
              {faqSectionPerSlug?.[faqSectionSlug] && (
                <FaqSection section={faqSectionPerSlug[faqSectionSlug]} shouldRedirectToContactUs />
              )}
            </Stack>
          </Column>
        </Columns>
      </Stack>
    </ContentWrapper>
  );
};

export default OrderDetailsCheckIn;
